$.routes.addFilter('isIndex', function(seg) {
	return ! seg || /^P[\d]+/.test(seg);
});

$.routes.map({
	'$any:once:fire': [
		'common',
		'navigation',
		'downloadButtons',
		'newsOrganizer',
		'notificationBar'
	],
	'$any:fire': [
		'accordion',
		'carousels',
		'controllers',
		'cart',
		'forms',
		'modals',
		'objectFitImages',
		'newsletter',
		'fittext',
		'solutions',
		'currency'
	],
	'$root': 'home',
	'$root:pop': 'home:pop',
	'about': 'about',
	'news': {
		'$any': 'news'
	},
	'resources': {
		'$slug': 'resources'
	},
	'products': {
		'$any': {
			'$root||$any': [
				'products',
				'productDetail',
				'hero'
			],
			'$root:pop': 'hero:pop',
			'$any:pop': 'hero:pop',
			'$root:unload': 'productDetail:unload',
			'$any:unload': 'productDetail:unload'
		}
	},
	'outlet-store': {
		'$any': [
			'products',
			'outlet'
		]
	},
	'programs': {
		'$slug': 'programs'
	},
	'projects': {
		'$any': {
			'$any||$root': 'project'
		},
		'$slug': 'projectDetail'
	},
	'promotions': {
		'$any': [
			'products'
		]
	},
	'find-a-rep': {
		'$any:once': 'representative',
		'$any': 'representative:load'
	},
	'search-results': {
		'$any': [
			'search'
		]
	},
	'search-results:pop': 'navigation:unloadSearch',
	'quote-cart': {
		'$root:pop': function() {
			$.set('cartTemplate', false);
		},
		'$any': [
			'checkout'
		]
	},
	'thank-you': 'thanks',
	// 'color-wizard': 'colorWizard',
	// 'color-wizard:pop': 'colorWizard:pop'
});

$.chain({
	isActive: function() {
		return this.hasClass('-is-active');
	},
	activate: function() {
		this.addClass('-is-active');

		return this;
	},
	deActivate: function() {
		this.removeClass('-is-active');

		return this;
	},
	ariaTrue: function() {
		this.attr('aria-hidden', true);

		return this;
	},
	ariaFalse: function() {
		this.attr('aria-hidden', false);

		return this;
	},
	ariaControls: function() {
		return $('#' + this.attr('aria-controls'));
	}
});

$.ready('routes:run');
